import CustomRoutes from "./CustomRoutes";
import { mainRoutes, moduleRoutes, profileModuleRoutes } from "./routes";

export { mainRoutes, moduleRoutes, profileModuleRoutes };
export default CustomRoutes;
